import { useState, useEffect } from "react";

export const showTooltip = (text) => {
    const tooltip = document.getElementById("tooltip")
    const tooltipText = document.getElementById("tooltip-text")
    tooltipText.innerHTML = text
    tooltip.style.display = "block"
}

export const hideTooltip = () => {
    const tooltip = document.getElementById("tooltip")
    tooltip.style.display = "none"
}

const Tooltip = ({ }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const tooltipClasses = ".expand_down, .expand_up, .external, .internal, .hide, .ps-menuitem-root, .expand_subtree, .expand_subtree_ref"

  useEffect(() => {
    const handleMouseMove = (event) => {
      setPosition({ x: event.clientX + 10, y: event.clientY + 10 });
    };

    const handleShow = (event) => {
        let element = event.target.closest(tooltipClasses); // Check multiple classes
        if (element) {
          let tooltipText = "";
          
          if (element.classList.contains("expand_down")) {
            tooltipText = "Show children"
          } else if (element.classList.contains("expand_up")) {
            tooltipText = "Show parent";
          } else if (element.classList.contains("external")) {
            tooltipText = "Show external references";
          } else if (element.classList.contains("internal")) {
            tooltipText = "Show internal references";
          } else if (element.classList.contains("expand_subtree")) {
            tooltipText = "Show subtree from node";
          } else if (element.classList.contains("expand_subtree_ref")) {
            tooltipText = "Show subtree and all references from node";
          } else if (element.classList.contains("hide")) {
            tooltipText = "Hide subtree";
          } else if (element.classList.contains("ps-menuitem-root") && element.classList.contains("disabled")) {
            tooltipText = "Click on a node to display node info";
          }
          if (tooltipText !== "") {
            showTooltip(tooltipText);
          }
        }
    };  

    const handleHide = (e) => {
            hideTooltip()
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseover", handleShow); // Update position as mouse moves
    document.addEventListener("mouseout", handleHide);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseover", handleShow);
      document.removeEventListener("mouseout", handleHide);
    };
  }, []);

  return (
    <div
      id="tooltip"
      style={{
        zIndex: 60000,
        position: "fixed",
        top: position.y,
        left: position.x,
        backgroundColor: "black",
        color: "white",
        padding: "5px 10px",
        borderRadius: "5px",
        fontSize: "12px",
        pointerEvents: "none",
        display: "none",
        transform: "translate(0, 0)",
      }}
    >
      <span id="tooltip-text"></span>
    </div>
  );
};

export default Tooltip;
